import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import makeData from '../services/makeData';
import { GENERAL } from '../config/Transaction/ProductGeneralConf';


import { COLUMNS } from '../config/Transaction/columns';
import { addAfterLoginNotification } from '../../../components/Toast/utils/notifications';

interface AsyncState {
    isLoading: {
      userData: boolean;
      usersData: boolean;
      userAdd: boolean;
      deleteUser: boolean;
    };
    isSuccess: boolean;
    isError: boolean;
  }
  
  interface TableState extends AsyncState {
    userData: any;
    totalCount: Number;
    addUserRes: any;
    deleteUserRes: any;
    fullResponse: Array<any>;
    usersData: Array<any>;
    errorMsg?: any;
    userTableColumns: any;
  }
  
  const initialState: TableState = {
    isLoading: {
      userData: true,
      usersData: true,
      userAdd: false,
      deleteUser: false,
    },
    isSuccess: false,
    isError: false,
    userData: null,
    addUserRes: null,
    deleteUserRes: null,
    totalCount: NaN,
    fullResponse: [],
    usersData: [],
    errorMsg: null,
    userTableColumns: COLUMNS,
  };
  
  // Fetch all users
  export const fetchAllUsers = createAsyncThunk('userData', async (_, thunkAPI) => {
    try {
      const res: any = await Service.getAllUsers();
      const madeData = makeData(res.data);
      return { usersData: madeData, fullResponse: res.data };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  });
  
  // Add a new user
  export const addUser = createAsyncThunk('user/addUser', async (data: any, thunkAPI) => {
    try {
      return await Service.addUser(data);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  });
  
  // Delete a user
//   export const deleteUser = createAsyncThunk('user/deleteUser', async (data: any, thunkAPI) => {
//     try {
//       return await Service.deleteUser(data);
//     } catch (error: any) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   });
  
  // Modify user table columns
  export const modifyUserColumns = createAsyncThunk('user/modifyColumns', async (data: any, thunkAPI) => {
    try {
      return data?.columns;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  });
  
  export const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchAllUsers.pending, (state) => {
          state.isLoading.userData = true;
          state.isError = false;
          state.errorMsg = null;
        })
        .addCase(fetchAllUsers.fulfilled, (state, action: any) => {
          state.isLoading.userData = false;
          state.isSuccess = true;
          state.isError = false;
          state.userData = action.payload.usersData;
          state.fullResponse = action.payload.fullResponse;
          state.errorMsg = null;
        })
        .addCase(fetchAllUsers.rejected, (state, action: any) => {
          state.isLoading.userData = false;
          state.isError = true;
          state.errorMsg = action.payload.errorMsg;
        })
  
        .addCase(addUser.pending, (state) => {
          state.isLoading.userAdd = true;
          state.isSuccess = false;
          state.isError = false;
          state.errorMsg = null;
          state.addUserRes = null;
        })
        .addCase(addUser.fulfilled, (state, action: any) => {
          addAfterLoginNotification('User added successfully', 'success');
          state.isLoading.userAdd = false;
          state.isSuccess = true;
          state.isError = false;
          state.addUserRes = action.payload;
        })
        .addCase(addUser.rejected, (state, action: any) => {
          addAfterLoginNotification(action.payload.errorMsg, 'error');
          state.isLoading.userAdd = false;
          state.isSuccess = false;
          state.isError = true;
          state.addUserRes = null;
          state.errorMsg = action.payload.errorMsg;
        })
  
        // .addCase(deleteUser.pending, (state) => {
        //   state.isLoading.deleteUser = true;
        //   state.isSuccess = false;
        //   state.isError = false;
        //   state.errorMsg = null;
        //   state.deleteUserRes = null;
        // })
        // .addCase(deleteUser.fulfilled, (state, action: any) => {
        //   addAfterLoginNotification('User deleted successfully', 'success');
        //   state.isLoading.deleteUser = false;
        //   state.isSuccess = true;
        //   state.isError = false;
        //   state.deleteUserRes = action.payload;
        // })
        // .addCase(deleteUser.rejected, (state, action: any) => {
        //   addAfterLoginNotification(action.payload.errorMsg, 'error');
        //   state.isLoading.deleteUser = false;
        //   state.isSuccess = false;
        //   state.isError = true;
        //   state.deleteUserRes = null;
        //   state.errorMsg = action.payload.errorMsg;
        // })
  
        .addCase(modifyUserColumns.pending, (state) => {
          state.isSuccess = false;
          state.isError = false;
          state.userTableColumns = initialState.userTableColumns;
        })
        .addCase(modifyUserColumns.fulfilled, (state, action: any) => {
          state.isSuccess = true;
          state.isError = false;
          state.userTableColumns = action.payload;
        })
        .addCase(modifyUserColumns.rejected, (state) => {
          state.isSuccess = false;
          state.isError = true;
          state.userTableColumns = initialState.userTableColumns;
        });
    },
  });
  

export default userSlice.reducer;
